/**
 * avatars/avatar-builder/avatar-builder.js
 * Xây dựng phân cấp khung xương và khối hình học 3D (Hierarchy & Geometry) cho BlockyAvatar
 */

import { computeDimensions, setupPelvis } from './builder-dimensions.js';
import { createBuilderMaterials } from './builder-materials.js';
import { buildShoesAndLegs } from './builder-legs.js';
import { buildTorso, buildArms } from './builder-torso-arms.js';
import { buildHead } from './builder-head.js';

export function buildAvatarHierarchy(avatar) {
  const scale = avatar.config.scale || 1.0;
  avatar.root.scale.set(scale, scale, scale);

  const dimensions = computeDimensions(avatar.config);
  avatar.dimensions = {
    legH: dimensions.legH,
    legW: dimensions.legW,
    legD: dimensions.legD,
    torsoH: dimensions.torsoH,
    torsoW: dimensions.torsoW,
    torsoD: dimensions.torsoD,
    headSize: dimensions.headSize,
    armH: dimensions.armH,
    armW: dimensions.armW,
    armD: dimensions.armD
  };

  const pelvis = setupPelvis(avatar, dimensions.legH);
  const materials = createBuilderMaterials(avatar);

  buildShoesAndLegs(avatar, pelvis, dimensions, materials);
  const torsoGroup = buildTorso(avatar, pelvis, dimensions, materials);
  buildArms(avatar, torsoGroup, dimensions, materials);
  buildHead(avatar, torsoGroup, dimensions, materials);
}
